export const reminderLimits = [
  { label: '5 Days', value: 5 },
  { label: '10 Days', value: 10 },
];
